define('bizzabo/views/popup/ImportAgendaView',[
    'backbone',
    'underscore',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/consts',
    'bizzabo/models/Global',
    'bizzabo/views/popup/PopupView',
    'bizzabo/views/UploadFileView',
    'hbars!bizzabo/templates/importAgenda'
], function(
    Backbone,
    _,
    BZAPI,
    UTILS,
    Consts,
    Global,
    PopupView,
    UploadFileView,
    template
    ) {

    var ImportAgendaView = PopupView.extend({

        events : {
            'click .doneButton' : 'doneClicked',
            'click .close' : 'cancelClicked'
        },

        initialize : function() {
            this.popUpInitialize();

            this.uploadFileView = new UploadFileView({
                actionURL : '/organizer/agenda/upload',
                fileAcceptType : '*',
                description : ' '
            });
            this.uploadFileView.on('success', this.agendaReceived, this);
        },

        remove : function() {
            this.uploadFileView.off('success', this.agendaReceived, this);
            this.uploadFileView.remove();
            this.$el.remove();
        },

        agendaReceived : function(jsonData) {
            this.$('.uploadPartnersFile').addClass('hide');
            this.$('.partnerProcessing').removeClass('hide');

            var thisView = this;
            var agenda = jsonData.agenda;
            var speakers = UTILS.ensureArray(agenda.speaker);
            var speakerWarnings = [];
            var sessionWarnings = [];
            var dayWarnings = [];

            // Re-assign CID for models
            var cidsMap = {};
            UTILS.applyRecursively(agenda, function(obj, value, key) {
                if (key == 'client-id') {
                    if (!cidsMap[value]) {
                        cidsMap[value] = _.uniqueId('c');
                    }
                    obj[key] = cidsMap[value];
                }
            });
            UTILS.applyRecursively(agenda, function(obj, value, key) {
                var endsWithCID = (/-cid$/.test(key));
                if (endsWithCID) {
                    obj[key] = cidsMap[value];
                }
            });

            // Ensure day and track are arrays
            UTILS.applyRecursively(agenda, function(obj, value, key) {
                if (key == 'day' || key == 'track') {
                    obj[key] = UTILS.ensureArray(value);
                }
            });

            // Make sure each track has an index
            _.each(agenda.day, function(day) {
                _.each(day.track, function(track, index) {
                    track.index = index;
                });
            });

            // Fix session-track relation issues
            _.each(agenda.day, function(day) {
                var sessionTracks = {};
                var firstTrack = (day.track.length > 0) ? day.track[0] : null;
                // map tracks per session
                _.each(day['relation-session-track'], function(relation) {
                    var sessionCid = relation['session-cid'];
                    var trackCid = relation['track-cid'];
                    var track = _.findWhere(day.track, {'client-id': trackCid});
                    sessionTracks[sessionCid] = sessionTracks[sessionCid] || [];
                    sessionTracks[sessionCid].push(track.index);
                });
                // Fix sessions with non-consecutive tracks
                _.each(sessionTracks, function(tracksForSession, sessionCid) {
                    var minTrack = _.min(tracksForSession);
                    var maxTrack = _.max(tracksForSession);
                    var wasFixed = false;
                    for (var i = minTrack; i < maxTrack; i++) {
                        var isMissingTrack = (tracksForSession.indexOf(i) < 0);
                        if (isMissingTrack) {
                            var track = _.findWhere(day.track, {'index': i});
                            day['relation-session-track'].push({
                                'session-cid': sessionCid,
                                'track-cid': track['client-id']
                            });
                            wasFixed = true;
                        }
                    }
                    if (wasFixed) {
                        var session = _.findWhere(day.session, {'client-id': sessionCid});
                        session.name && sessionWarnings.push(session.name);
                    }
                });
                // Fix sessions with no tracks at all
                _.each(day.session, function(session) {
                    if (!sessionTracks[session['client-id']]) {
                        day['relation-session-track'].push({
                            'session-cid': session['client-id'],
                            'track-cid': firstTrack['client-id']
                        });
                        session.name && sessionWarnings.push(session.name);
                    }
                });
            });

            var eventId = this.model.get('eventId') || 'new';
            var event = Global.modelPool.getEvent(eventId);
            var eventNumberOfDays = event.numberOfDays();
            var agendaNumberOfDays = agenda.day.length;
            if (agendaNumberOfDays > eventNumberOfDays) {
                dayWarnings.push('Only the first ' + eventNumberOfDays + ' day(s) were imported.');
            }

            var finishedProcessing = _.after(speakers.length, function() {
                var days = thisView.model.get('day') ? thisView.model.get('day').length : 1;
                thisView.model.removeDays(days);
                thisView.model.get('speaker').reset();
                thisView.model.dayErrors = {};
                thisView.model.speakerErrors = {};
                thisView.model.set(thisView.model.parse(agenda));
                thisView.model.syncEventDatesAndAgendaDays();
                thisView.model.validate && thisView.model.validate();
                thisView.model.validateSessions();
                thisView.model.validateSpeakers();
                thisView.model.trigger('imported');
                _.defer(function() {
                    thisView.$('.loading').addClass('hide');
                    thisView.$('.agenda-import-instructions').addClass('hide');
                    thisView.$('.modal-footer').addClass('hide');
                    thisView.$('.doneButton').removeClass('hide');
                    thisView.$('.partnerProgress').empty();
                    thisView.$('.agenda-import-completed').removeClass('hide');
                    var numberOfErrors = thisView.model.numberOfErrors();
                    if (numberOfErrors > 0) {
                        Backbone.trigger(Consts.Notifications.router.NAVIGATE_REQUEST, 'event/' + (thisView.model.get('eventId') || 'new') + '/agenda/errors', {
                            trigger : true
                        });
                        thisView.$('.agenda-import-errors').html(', but it has ' + numberOfErrors + ' error(s).');
                        thisView.$('.agenda-import-dont-worry').removeClass('hide');
                    }
                    if (dayWarnings.length > 0) {
                        thisView.$('.agenda-import-day-warnings').html(dayWarnings[0]);
                    }
                    if (sessionWarnings.length > 0) {
                        thisView.$('.agenda-import-session-warnings').html('The tracks of ' + sessionWarnings.length + ' sessions(s) were adjusted: ' + sessionWarnings.join(', ') + '.');
                    }
                    if (speakerWarnings.length > 0) {
                        thisView.$('.agenda-import-speaker-warnings').html('The photos of ' + speakerWarnings.length + ' speaker(s) could not be imported: ' + speakerWarnings.join(', ') + '.');
                    }
                });
            });

            if (speakers.length <= 0) {
                finishedProcessing();
            }

            var MAX_PARALLEL_SEND = 10;

            var processed = 0;
            var processedSpeaker = function() {
                processed++;
                thisView.$('.partnerProgress').html('Processing ' + processed + ' out of ' + speakers.length + " speakers. Looks like it's going to be a great event!");
                processNext();
                finishedProcessing();
            };

            var processQueue = speakers.concat();
            var processing = 0;
            var processNext = function() {
                if (processQueue.length == 0) {
                    return;
                }
                if (processing >= MAX_PARALLEL_SEND) {
                    return;
                }

                var speaker = processQueue.shift();
                var logoURL = speaker['photo-url'];
                if (logoURL && (logoURL.length > 0)) {
                    processing++;
                    BZAPI.replaceImageURL(logoURL, function(location) {
                        processing--;
                        speaker['photo-url'] = location;
                        processedSpeaker();
                    }, function() {
                        processing--;
                        delete speaker['photo-url'];
                        var fullName = _.compact([
                            speaker['first-name'],
                            speaker['last-name']
                        ]).join(' ');
                        if (fullName) {
                            speakerWarnings.push(fullName);
                        }
                        processedSpeaker();
                    });
                } else {
                    processedSpeaker();
                }

                processNext();
            };

            processNext();
        },

        // Actions

        cancelClicked : function() {
            this.hide();
        },

        doneClicked : function() {
            this.hide();
        },

        // Rendering

        render : function() {
            var html = template({});
            this.$el.html(html);
            this.$('.uploadFile').html(this.uploadFileView.render().el);

            return this;
        }
    });

    return ImportAgendaView;

});
